export default __webpack_public_path__ + "static/media/table.d9b26e3c.svg";